import type { NextPage } from "next";
import { useTranslation } from "next-i18next/pages";
import SubpageShell from "components/common/SubpageShell";
import FounderStory from "components/about/FounderStory";
import Companies from "components/about/Companies";
import Testimonial from "components/home/Testimonial";
import {
  CMS_REVALIDATE_SECONDS,
  serverSideCmsTranslations
} from "lib/cms/translations";

export async function getStaticProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideCmsTranslations(locale, ["common", "about"]))
    },
    revalidate: CMS_REVALIDATE_SECONDS
  };
}

const About: NextPage = () => {
  const { t } = useTranslation("about");

  return (
    <SubpageShell
      title={t("global.websiteTitle")}
      description={t("global.websiteDescription")}
      heading={[
        t("header.primaryHeading.first"),
        t("header.primaryHeading.second"),
        t("header.primaryHeading.third")
      ].join(" ")}
      subtitle={t("header.subHeading")}
      path="/ueber-uns"
      doAnimation
    >
      <FounderStory />
      <Companies />
      <Testimonial doAnimation />
    </SubpageShell>
  );
};

export default About;
